import { REMEMBERED_TIME_CLOCK_TYPE } from './constants';

export const getSavedTimeClockType = () =>
  localStorage.getItem(REMEMBERED_TIME_CLOCK_TYPE);

export const saveTimeClockType = type =>
  localStorage.setItem(REMEMBERED_TIME_CLOCK_TYPE, type);
